/*!
// <copyright file="Notifications.js" company="Microsoft">
//     Copyright (c) Microsoft Corporation.  All rights reserved.
// </copyright>
*/

import { resources } from "@ax/office-cdn-app-resources";

export namespace notifications {

    export interface AddNotificationOptions {

        /** Indicates whether a time stamp should be displayed with the notification; true by default. */
        IncludeTimeStamp?: boolean;

        /** Contains text and action properties that indicate how the option link should be displayed. */
        LinkOptions?: LinkOptions;

        /** The string that should be copied to the user's clipboard; if not present no copy button is shown. */
        CopyText?: string;
    }

    export interface LinkOptions {

        /** The text that should be displayed on the link. */
        Text: string;

        /** The action that should be executed when the link is clicked. */
        Action: () => void;
    }

    /* jshint -W069 */
    /** The types of notifications. */
    export enum NotificationType {

        /** The normal notification type. */
        notification = "notification",

        /** The error notification type. */
        error = "error"
    }
    /* jshint +W069 */

    /** Represents a notification. */
    export class Notification {

        /** The type of the notification. */
        public NotificationType: NotificationType;

        /** The notification message. */
        public Message: string;

        /** The notification message details. */
        public Details: string;

        /**
         * @param notificationType The type of the notification.
         * @param message The notification message.
         * @param details The notification message details.
         */
        constructor(notificationType: NotificationType, message: string, details?: string) {
            this.NotificationType = notificationType;
            this.Message = message;
            this.Details = details;
        }

        /**
         * Gets the formatted message for the notification.
         * @returns The formatted message for the notification.
         */
        public getFormattedMessage(): string {
            var formattedMessage;
            if (this.Details) {
                formattedMessage = resources.dynamicsApp.notification_WithDetailsMessageFormat(this.Message, this.Details);
            } else {
                formattedMessage = this.Message;
            }
            return formattedMessage;
        }
    }
}
